import { put, call } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';
import { setRedirect } from 'auth/actions';
import { sprintAddDataPurchase, bypassedAddDataPurchase, quickAddDataPurchase } from 'app/routes';

export function* sprintAddDataPurchaseNavigate({ subId }) {
  yield put(setRedirect(sprintAddDataPurchase(subId)));
  yield call(authenticateUser);
}

export function* bypassedAddDataPurchaseNavigate({ subId }) {
  yield put(setRedirect(bypassedAddDataPurchase(subId)));
  yield call(authenticateUser);
}

export function* quickAddDataPurchaseNavigate({ subId }) {
  yield put(setRedirect(quickAddDataPurchase(subId)));
  yield call(authenticateUser);
}
